import styled from "styled-components";

export const SeeAlsoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  white-space: pre;
  margin-top: ${(props) => props.theme.space.sm};
`;
